import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ServicoBio, BioPagina } from '../services/servico-bio.service';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { NotificationService } from '@progress/kendo-angular-notification';

interface PaletaPreset {
  nome: string;
  emoji: string;
  corPrimaria: string;
  corSecundaria: string;
  corFundo: string;
  corFundoCard: string;
  corBotaoCta?: string;
}

const PALETAS_PREDEFINIDAS: PaletaPreset[] = [
  { nome: 'Clássico Quente', emoji: '🔥', corPrimaria: '#E84C5E', corSecundaria: '#C62828', corFundo: '#F5E6D3', corFundoCard: '#FFFFFF' },
  { nome: 'Hamburgueria Dark', emoji: '🍔', corPrimaria: '#F59E0B', corSecundaria: '#EF4444', corFundo: '#1A1A2E', corFundoCard: '#2D2D44' },
  { nome: 'Sorveteria Pastel', emoji: '🍦', corPrimaria: '#EC4899', corSecundaria: '#8B5CF6', corFundo: '#FFF1F2', corFundoCard: '#FFFFFF' },
  { nome: 'Natural & Saudável', emoji: '🥗', corPrimaria: '#059669', corSecundaria: '#10B981', corFundo: '#F0FDF4', corFundoCard: '#FFFFFF' },
  { nome: 'Café & Padaria', emoji: '☕', corPrimaria: '#92400E', corSecundaria: '#B45309', corFundo: '#FEF3C7', corFundoCard: '#FFFBEB' },
  { nome: 'Japonês Minimalista', emoji: '🍣', corPrimaria: '#DC2626', corSecundaria: '#1F2937', corFundo: '#FAFAFA', corFundoCard: '#FFFFFF' },
  { nome: 'Italiano Clássico', emoji: '🍕', corPrimaria: '#DC2626', corSecundaria: '#15803D', corFundo: '#FEF2F2', corFundoCard: '#FFFFFF' },
  { nome: 'Premium Gourmet', emoji: '✨', corPrimaria: '#D4AF37', corSecundaria: '#D4AF37', corFundo: '#0F0F0F', corFundoCard: '#1A1A1A' },
  { nome: 'Açaí Tropical', emoji: '🫐', corPrimaria: '#7C3AED', corSecundaria: '#EC4899', corFundo: '#F5F3FF', corFundoCard: '#FFFFFF' },
  { nome: 'Churrasco na Brasa', emoji: '🥩', corPrimaria: '#FF6B35', corSecundaria: '#DC2626', corFundo: '#1C1917', corFundoCard: '#292524' },
  { nome: 'Doceria Candy', emoji: '🧁', corPrimaria: '#E11D48', corSecundaria: '#F472B6', corFundo: '#FDF2F8', corFundoCard: '#FFFFFF' },
  { nome: 'Mexicano Fiesta', emoji: '🌮', corPrimaria: '#EA580C', corSecundaria: '#16A34A', corFundo: '#FEF9C3', corFundoCard: '#FFFFFF' },
  { nome: 'Frutos do Mar', emoji: '🦐', corPrimaria: '#0369A1', corSecundaria: '#0EA5E9', corFundo: '#F0F9FF', corFundoCard: '#FFFFFF' },
  { nome: 'Vegano Earth', emoji: '🌱', corPrimaria: '#4D7C0F', corSecundaria: '#A16207', corFundo: '#FEFCE8', corFundoCard: '#F7FEE7' },
  { nome: 'Boteco & Cerveja', emoji: '🍺', corPrimaria: '#CA8A04', corSecundaria: '#B91C1C', corFundo: '#1E293B', corFundoCard: '#334155' },
  { nome: 'Árabe & Oriental', emoji: '🧆', corPrimaria: '#B45309', corSecundaria: '#A16207', corFundo: '#FFFBEB', corFundoCard: '#FEF3C7' },
  { nome: 'Poke Havaiano', emoji: '🥝', corPrimaria: '#0D9488', corSecundaria: '#F97316', corFundo: '#F0FDFA', corFundoCard: '#FFFFFF' },
  { nome: 'Pizzaria Noturna', emoji: '🌙', corPrimaria: '#EF4444', corSecundaria: '#F59E0B', corFundo: '#18181B', corFundoCard: '#27272A' },
  { nome: 'Lanchonete Retro', emoji: '🎸', corPrimaria: '#E11D48', corSecundaria: '#06B6D4', corFundo: '#FFF7ED', corFundoCard: '#FFFFFF' },
  { nome: 'Marmitex Caseiro', emoji: '🍱', corPrimaria: '#D97706', corSecundaria: '#059669', corFundo: '#FFFBEB', corFundoCard: '#FFFFFF' }
];

@Component({
  selector: 'app-bio-aparencia',
  templateUrl: './bio-aparencia.component.html',
  styleUrls: ['./bio-aparencia.component.scss']
})
export class BioAparenciaComponent implements OnInit {

  bioPagina: BioPagina;
  carregando = true;
  salvando = false;
  modoPreview: 'mobile' | 'desktop' = 'mobile';
  urlPreview: SafeResourceUrl;
  timestampPreview = Date.now();

  @ViewChild('iframePreview') iframePreview: ElementRef<HTMLIFrameElement>;

  fontesDisponiveis = [
    { label: 'Padrão (system-ui)', value: '' },
    { label: 'Inter', value: 'Inter' },
    { label: 'Poppins', value: 'Poppins' },
    { label: 'Nunito', value: 'Nunito' },
    { label: 'Lato', value: 'Lato' },
    { label: 'Montserrat', value: 'Montserrat' },
    { label: 'Roboto', value: 'Roboto' },
    { label: 'Open Sans', value: 'Open Sans' },
    { label: 'Raleway', value: 'Raleway' },
    { label: 'Merriweather', value: 'Merriweather' },
    { label: 'Playfair Display', value: 'Playfair Display' },
    { label: 'Bebas Neue', value: 'Bebas Neue' },
    { label: 'Syne', value: 'Syne' },
    { label: 'Urbanist', value: 'Urbanist' },
    { label: 'Questrial', value: 'Questrial' },
    { label: 'Geist', value: 'Geist' }
  ];
  fontesPermitidas = new Set(this.fontesDisponiveis.map(f => f.value));

  paletasPreDefinidas = PALETAS_PREDEFINIDAS;
  paletaSelecionadaIndex = -1;
  corTextoAuto = true;
  mostrarControles = true;
  coresOriginais: Partial<BioPagina> = {};

  constructor(
    private servicoBio: ServicoBio,
    private autorizacaoService: AutorizacaoService,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.autorizacaoService.fetchUser().subscribe(usuario => {
      if (!usuario?.empresa?.id) {
        this.bioPagina = null;
        this.carregando = false;
        this.notificationService.show({
          content: 'Não foi possível carregar os dados da empresa.',
          type: { style: 'error', icon: true },
          position: { horizontal: 'right', vertical: 'top' },
          hideAfter: 3000
        });
        return;
      }

      this.servicoBio.obterBioPagina(usuario.empresa.id).then((data: BioPagina) => {
        this.bioPagina = data;
        this.bioPagina.fonte = this.normalizarFonteSelecionada(this.bioPagina?.fonte);
        this.coresOriginais = {
          corPrimaria: data.corPrimaria,
          corSecundaria: data.corSecundaria,
          corFundo: data.corFundo,
          corTexto: data.corTexto,
          corFundoCard: data.corFundoCard,
          corBotaoCta: data.corBotaoCta,
          borderRadius: data.borderRadius,
          fonte: data.fonte
        };
        this.carregando = false;
        this.atualizarUrlPreview();
      }).catch(() => {
        this.bioPagina = null;
        this.carregando = false;
      });
    });
  }

  atualizarUrlPreview() {
    if (!this.bioPagina?.slug) return;
    const url = window.location.origin + '/bio/' + this.bioPagina.slug + '?preview=true&t=' + this.timestampPreview;
    this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  recarregarPreview() {
    this.timestampPreview = Date.now();
    this.atualizarUrlPreview();
  }

  salvar() {
    if (!this.bioPagina || !this.bioPagina.id) return;
    this.salvando = true;
    this.servicoBio.atualizarBioPagina(this.bioPagina.id, {
      corPrimaria: this.bioPagina.corPrimaria,
      corSecundaria: this.bioPagina.corSecundaria,
      corFundo: this.bioPagina.corFundo,
      corTexto: this.bioPagina.corTexto,
      corFundoCard: this.bioPagina.corFundoCard,
      corBotaoCta: this.bioPagina.corBotaoCta,
      borderRadius: this.bioPagina.borderRadius,
      fonte: this.normalizarFonteSelecionada(this.bioPagina.fonte)
    }).then((data: BioPagina) => {
      if (data) {
        this.bioPagina = { ...this.bioPagina, ...data };
        this.bioPagina.fonte = this.normalizarFonteSelecionada(this.bioPagina?.fonte);
      }
      this.coresOriginais = {
        corPrimaria: this.bioPagina.corPrimaria,
        corSecundaria: this.bioPagina.corSecundaria,
        corFundo: this.bioPagina.corFundo,
        corTexto: this.bioPagina.corTexto,
        corFundoCard: this.bioPagina.corFundoCard,
        corBotaoCta: this.bioPagina.corBotaoCta,
        borderRadius: this.bioPagina.borderRadius,
        fonte: this.bioPagina.fonte
      };
      this.salvando = false;
      this.recarregarPreview();
      this.notificationService.show({
        content: 'Aparência salva com sucesso!',
        type: { style: 'success', icon: true },
        position: { horizontal: 'right', vertical: 'top' },
        hideAfter: 3000
      });
    }).catch(() => {
      this.salvando = false;
      this.notificationService.show({
        content: 'Erro ao salvar. Tente novamente.',
        type: { style: 'error', icon: true },
        position: { horizontal: 'right', vertical: 'top' },
        hideAfter: 3000
      });
    });
  }

  abrirEmNovaAba() {
    if (!this.bioPagina?.slug) return;
    window.open(window.location.origin + '/bio/' + this.bioPagina.slug, '_blank');
  }

  // --- Preview em tempo real via postMessage ---

  enviarParaPreview() {
    if (!this.bioPagina || !this.iframePreview?.nativeElement?.contentWindow) return;
    this.iframePreview.nativeElement.contentWindow.postMessage({
      tipo: 'bio-preview-update',
      corPrimaria: this.bioPagina.corPrimaria,
      corSecundaria: this.bioPagina.corSecundaria,
      corFundo: this.bioPagina.corFundo,
      corTexto: this.bioPagina.corTexto,
      corFundoCard: this.bioPagina.corFundoCard,
      corBotaoCta: this.bioPagina.corBotaoCta,
      borderRadius: this.bioPagina.borderRadius,
      fonte: this.bioPagina.fonte
    }, '*');
  }

  // --- Paletas ---

  aplicarPaleta(index: number) {
    if (!this.bioPagina) return;
    const p = this.paletasPreDefinidas[index];
    this.paletaSelecionadaIndex = index;
    this.bioPagina.corPrimaria = p.corPrimaria;
    this.bioPagina.corSecundaria = p.corSecundaria;
    this.bioPagina.corFundo = p.corFundo;
    this.bioPagina.corFundoCard = p.corFundoCard;
    this.bioPagina.corBotaoCta = p.corBotaoCta || p.corPrimaria;
    if (this.corTextoAuto) {
      this.bioPagina.corTexto = this.getContrastText(p.corFundoCard);
    }
    this.enviarParaPreview();
  }

  deselecionarPaleta() {
    this.paletaSelecionadaIndex = -1;
  }

  // --- Cor de texto auto ---

  atualizarCorTextoAuto() {
    if (this.corTextoAuto && this.bioPagina) {
      this.bioPagina.corTexto = this.getContrastText(this.bioPagina.corFundoCard);
    }
    this.enviarParaPreview();
  }

  toggleCorTextoAuto() {
    this.corTextoAuto = !this.corTextoAuto;
    this.atualizarCorTextoAuto();
  }

  // --- Alterações pendentes ---

  get temAlteracoesPendentes(): boolean {
    if (!this.bioPagina) return false;
    return this.bioPagina.corPrimaria !== this.coresOriginais.corPrimaria
      || this.bioPagina.corSecundaria !== this.coresOriginais.corSecundaria
      || this.bioPagina.corFundo !== this.coresOriginais.corFundo
      || this.bioPagina.corTexto !== this.coresOriginais.corTexto
      || this.bioPagina.corFundoCard !== this.coresOriginais.corFundoCard
      || this.bioPagina.corBotaoCta !== this.coresOriginais.corBotaoCta
      || this.bioPagina.borderRadius !== this.coresOriginais.borderRadius
      || this.bioPagina.fonte !== this.coresOriginais.fonte;
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    if (this.temAlteracoesPendentes) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  // --- Resetar ---

  resetar() {
    if (!this.bioPagina) return;
    this.bioPagina.corPrimaria = this.coresOriginais.corPrimaria;
    this.bioPagina.corSecundaria = this.coresOriginais.corSecundaria;
    this.bioPagina.corFundo = this.coresOriginais.corFundo;
    this.bioPagina.corTexto = this.coresOriginais.corTexto;
    this.bioPagina.corFundoCard = this.coresOriginais.corFundoCard;
    this.bioPagina.corBotaoCta = this.coresOriginais.corBotaoCta;
    this.bioPagina.borderRadius = this.coresOriginais.borderRadius;
    this.bioPagina.fonte = this.normalizarFonteSelecionada(this.coresOriginais.fonte);
    this.paletaSelecionadaIndex = -1;
    this.enviarParaPreview();
  }

  // --- Toggle controles ---

  toggleControles() {
    this.mostrarControles = !this.mostrarControles;
  }

  // --- Acessibilidade ---

  get verificacoesAcessibilidade(): { label: string; cor1: string; cor2: string; ratio: number; passa: boolean }[] {
    if (!this.bioPagina) return [];
    const checks = [
      { label: 'Texto / Card', cor1: this.bioPagina.corTexto, cor2: this.bioPagina.corFundoCard },
      { label: 'Título / Fundo', cor1: this.bioPagina.corTexto, cor2: this.bioPagina.corFundo },
      { label: 'Primary / Card', cor1: this.bioPagina.corPrimaria, cor2: this.bioPagina.corFundoCard },
      { label: 'Texto / Badge', cor1: this.bioPagina.corTexto, cor2: this.bioPagina.corSecundaria }
    ];
    return checks.map(c => {
      const ratio = this.getContrastRatio(c.cor1, c.cor2);
      return { ...c, ratio: Math.round(ratio * 10) / 10, passa: ratio >= 4.5 };
    });
  }

  // --- Helpers de cor (privados) ---

  private getContrastText(bgHex: string): string {
    const lum = this.getRelativeLuminance(bgHex);
    return lum > 0.179 ? '#1A1A1A' : '#FFFFFF';
  }

  private getRelativeLuminance(hex: string): number {
    const rgb = this.hexToRgb(hex);
    if (!rgb) return 0;
    const [r, g, b] = [rgb.r, rgb.g, rgb.b].map(c => {
      const s = c / 255;
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  private getContrastRatio(fg: string, bg: string): number {
    const l1 = this.getRelativeLuminance(fg);
    const l2 = this.getRelativeLuminance(bg);
    const lighter = Math.max(l1, l2);
    const darker = Math.min(l1, l2);
    return (lighter + 0.05) / (darker + 0.05);
  }

  private hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    if (!hex) return null;
    const clean = hex.replace('#', '');
    if (clean.length !== 6) return null;
    return {
      r: parseInt(clean.substring(0, 2), 16),
      g: parseInt(clean.substring(2, 4), 16),
      b: parseInt(clean.substring(4, 6), 16)
    };
  }

  private normalizarFonteSelecionada(fonte: string): string {
    const valor = String(fonte || '').trim();
    if (!valor) return '';
    return this.fontesPermitidas.has(valor) ? valor : '';
  }
}
